import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Globe2 } from 'lucide-react'
import { LANGUAGES, tr } from 'i18n'
import { changeInterfaceLanguage } from './LanguageProvider'
import './preferences.scss'

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const userId = useSelector(state => state.user.userId)
  return <label className="erp-language-switcher"><Globe2 size={16} aria-hidden="true" />
    <select aria-label={tr('Язык интерфейса')} value={i18n.language} onChange={event => changeInterfaceLanguage(event.target.value, userId)}>
      {LANGUAGES.map(language => <option key={language.code} value={language.code} lang={language.code}>{language.label}</option>)}
    </select>
  </label>
}
